import { render, staticRenderFns } from "./CustomerHelp.vue?vue&type=template&id=26980ee3&scoped=true&"
import script from "./CustomerHelp.vue?vue&type=script&lang=js&"
export * from "./CustomerHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26980ee3",
  null
  
)

export default component.exports